"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleInfoItemsCreator = void 0;
require("@veeam/components");
require("../../core/baseTypes");
const contexts_1 = require("../../core/contexts");
const helpers_1 = require("./helpers");
require("./models/CommonScheduleModel");
require("./types");
class ScheduleInfoItemsCreator {
    constructor(labels, texts, model) {
        this.labels = labels;
        this.texts = texts;
        this.model = model;
        this.getScheduleInfoItemValue = (createCount, filledText, emptyText, isDisabled = false, disabledText = '') => {
            let text = parseInt(createCount) >= 1 ? filledText : emptyText;
            if (isDisabled) {
                text = disabledText;
            }
            return text;
        };
        this.getUnitSingularPluralLabel = (count, retentionType) => {
            return helpers_1.getUnitSingularPluralLabel(this.texts, count, retentionType);
        };
        this.getRowFirstValueForFormatter = () => {
            const modelValue = this.model.getValue();
            const scheduleValue = modelValue.rows.first.schedule;
            const retentionCount = modelValue.rows.first.fields.count;
            const singular = this.labels.rowFirst.wordForm.singular;
            const plural = this.labels.rowFirst.wordForm.singular;
            return {
                create: `${helpers_1.getScheduleCount(scheduleValue)}`,
                keep: `${retentionCount}`,
                createdItemsLabel: helpers_1.getScheduleCount(scheduleValue) === 1 ? singular : plural,
                keepItemsLabel: retentionCount === 1 ? singular : plural,
            };
        };
        this.getRowSecondValueForFormatter = () => {
            var _a, _b;
            const modelValue = this.model.getValue();
            const scheduleValue = modelValue.rows.second.schedule;
            const retentionCount = modelValue.rows.second.fields.count;
            const singular = ((_a = this.labels.rowSecond) === null || _a === void 0 ? void 0 : _a.wordForm.singular) || '';
            const plural = ((_b = this.labels.rowSecond) === null || _b === void 0 ? void 0 : _b.wordForm.singular) || '';
            return {
                create: `${helpers_1.getScheduleCount(scheduleValue)}`,
                keep: `${retentionCount}`,
                createdItemsLabel: helpers_1.getScheduleCount(scheduleValue) === 1 ? singular : plural,
                keepItemsLabel: retentionCount === 1 ? singular : plural,
            };
        };
        this.getCommonRowThirdValueForFormatter = () => {
            var _a, _b;
            const modelValue = this.model.getValue();
            const scheduleValue = modelValue.rows.third.schedule;
            const retentionCount = modelValue.rows.third.fields.count;
            const retentionType = modelValue.rows.third.fields.type;
            const singular = ((_a = this.labels.rowThird) === null || _a === void 0 ? void 0 : _a.wordForm.singular) || '';
            const plural = ((_b = this.labels.rowThird) === null || _b === void 0 ? void 0 : _b.wordForm.singular) || '';
            const scheduleValueCount = helpers_1.getScheduleCount(scheduleValue);
            return {
                create: `${scheduleValueCount}`,
                keep: `${retentionCount}`,
                keepUnit: this.getUnitSingularPluralLabel(retentionCount, retentionType),
                createdItemsLabel: scheduleValueCount === 1 ? singular : plural,
            };
        };
        this.getRowThirdValueForFormatterWithExcluded = () => {
            var _a, _b;
            const modelValue = this.model.getValue();
            const scheduleValue = modelValue.rows.third.schedule;
            const singular = ((_a = this.labels.rowThird) === null || _a === void 0 ? void 0 : _a.wordForm.singular) || '';
            const plural = ((_b = this.labels.rowThird) === null || _b === void 0 ? void 0 : _b.wordForm.singular) || '';
            const thirdRowValue = this.getCommonRowThirdValueForFormatter();
            const excludedScheduleDaysCount = scheduleValue.filter((item) => item === false).length;
            return Object.assign(Object.assign({}, thirdRowValue), { excludedStr: excludedScheduleDaysCount > 0
                    ? contexts_1.parseTextConfig(this.texts.scheduleRowThirdExcludedStr, {
                        excluded: `${excludedScheduleDaysCount}`,
                        excludedUnit: excludedScheduleDaysCount === 1 ? singular : plural,
                    })
                    : '' });
        };
        this.getCommonScheduleInfoItems = (rowFirstValue, rowSecondValue, rowThirdValue) => {
            var _a, _b;
            const isSecondRowEnabled = this.model.isSecondRowExistingAndEnabled();
            const isThirdRowEnabled = this.model.isThirdRowExistingAndEnabled();
            const items = [
                {
                    label: this.labels.rowFirst.title,
                    value: rowFirstValue,
                },
                isSecondRowEnabled && {
                    label: ((_a = this.labels.rowSecond) === null || _a === void 0 ? void 0 : _a.title) || '',
                    value: rowSecondValue,
                },
                isThirdRowEnabled && {
                    label: ((_b = this.labels.rowThird) === null || _b === void 0 ? void 0 : _b.title) || '',
                    value: rowThirdValue,
                },
            ].filter(Boolean);
            return items;
        };
        this.getTooltipDataItems = (schedule, daysItems) => {
            return daysItems.filter((_, index) => schedule[index] === false).map(({ name }) => name);
        };
        this.getTooltipData = (schedule, daysItems, excludedUnitsLabel) => {
            if (!schedule.length) {
                return;
            }
            const items = this.getTooltipDataItems(schedule, daysItems);
            if (!items.length) {
                return;
            }
            return {
                label: excludedUnitsLabel,
                items,
            };
        };
        this.labels = labels;
        this.texts = texts;
        this.model = model;
    }
}
exports.ScheduleInfoItemsCreator = ScheduleInfoItemsCreator;
//# sourceMappingURL=ScheduleInfoItemsCreator.js.map